export default "__VITE_ASSET__olX8Doya__"